import BlockContent from "@pathwright/web/src/modules/blocks/BlockContent"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledWrapper = styled.div`
  #blocks-content-editor {
    border-radius: 10px;
  }

  .ContentEditorBlocks {
    border-radius: 10px;
    padding-bottom: 20px;
  }
`

const ManagePageBuilder = (props) => {
  return (
    <StyledWrapper>
      <BlockContent
        contextKey={`/page-${props.id}`}
        templateVariables={{}}
        mode="EDIT"
      />
    </StyledWrapper>
  )
}

ManagePageBuilder.displayName = "ManagePageBuilder"

ManagePageBuilder.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired
}

export default ManagePageBuilder
